const n = {
  "spacing-0": "0",
  "spacing-0,5": "0,5",
  "spacing-1": "1",
  "spacing-1,5": "1,5",
  "spacing-2": "2",
  "spacing-2,5": "2,5",
  "spacing-3": "3",
  "spacing-4": "4",
  "spacing-5": "5",
  "spacing-6": "6",
  "spacing-7": "7",
  "spacing-8": "8",
  "spacing-10": "10",
  "spacing-12": "12",
  "spacing-14": "14",
  "spacing-16": "16",
  "spacing-20": "20",
  "spacing-24": "24",
  "spacing-32": "32",
  "spacing-40": "40",
  "container-padding-mobile": "5",
  "container-padding-desktop-40": "10",
  "container-padding-desktop-80": "20",
  "container-padding-desktop-120": "30"
};
export {
  n as spacingSemanticTokens
};
